t = require('views/internal/teacup-with-helpers')('select_board')

module.exports = t.renderable ({ name, id, closed, orgName })->
  t.li '.item', ->
    t.a '.name.js-select-board', { href: '#', title: name, 'data-id': id }, ->
      t.span '.item-name', ->
        t.text name
        if closed
          t.text ' '
          t.span '.quiet', ->
            t.format 'archived'
      if orgName
        t.span '.sub-name', ->
          t.format 'in-orgname', { orgName }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/select_board.coffee